// Icons
import { CloseRounded } from '@mui/icons-material';

// Styled
import { StyledHeader, HeaderText, CloseButton } from './styled';
import CustomButton from 'components/Button/CustomButton';

interface HeaderPropTypes {
  renderCloseIcon?: boolean;
  handleClose?: () => void;
  handleClearFilters?: () => void;
  readOnly?: boolean;
}

const Header = ({
  renderCloseIcon = true,
  handleClose,
  handleClearFilters,
  readOnly = false,
}: HeaderPropTypes) => {
  return (
    <StyledHeader>
      <HeaderText>Filters</HeaderText>
      {!readOnly && (
        <CustomButton
          variant="outlined"
          onClick={handleClearFilters}
          color="error"
          sx={{
            marginLeft: 'auto',
            marginRight: '20px',
            borderColor: '#D32F2F',
            color: '#D32F2F',
            textTransform: 'capitalize',
            fontSize: '13px',
            fontWeight: 600,
            padding: '3px 8px',
          }}
        >
          Clear Filters
        </CustomButton>
      )}
      {renderCloseIcon && (
        <CloseButton onClick={handleClose}>
          <CloseRounded />
        </CloseButton>
      )}
    </StyledHeader>
  );
};

export default Header;
